import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, getFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_AUTH_DOMAIN",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_STORAGE_BUCKET",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Persistance hors ligne (IndexedDB) : les lectures déjà vues restent
// disponibles sans connexion, les écritures sont mises en file d'attente et
// synchronisées automatiquement au retour du réseau (les règles Firestore
// s'appliquent toujours à ce moment-là, hors ligne ne contourne aucune
// sécurité). persistentMultipleTabManager permet plusieurs onglets ouverts
// en même temps sans perdre la persistance — contrairement à l'ancienne API
// enableIndexedDbPersistence (dépréciée), qui échouait dans ce cas précis.
// Si IndexedDB est indisponible (navigation privée sur certains navigateurs,
// environnement de test), on retombe sur le cache mémoire plutôt que de
// faire planter l'app.
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
} catch {
  db = getFirestore(app);
}
export { db };
export default app;
